const foodunit = {
  getlist: 'foodunit/getlist-by-admin',
  add: 'foodunit/add',
  update: 'foodunit/update',
  remove: 'foodunit/remove',
  get: 'foodunit/get-by-admin',
  getall: 'foodunit/getall',
  convert: 'foodunit/convert',
  clearcache: 'foodunit/clear-cache',
}
export default foodunit
